<app-ng-dynamic-breadcrumb [symbol]="'>'" [bgColor]="'transparent'" [fontSize]="'15px'" [fontColor]="'#161c24'"
  [lastLinkColor]="'#323639'">
</app-ng-dynamic-breadcrumb>

<div class="auction-content-body position-relative">
  <div class="card auction-content-main m-0 p-3">
    <h3 class="mt-2 fs-lg">Individual winner</h3>
    <div class="table-responsive auto-scroll" *ngIf="individualAuctions.length; else fallback">
      <table datatable class="auction-dt table table-striped" [dtOptions]="dtOptions">
        <thead class="sticky-hdr">
          <tr>
            <th scope="col"></th>
            <th 
              *ngFor="let item of headingOrder" 
              [ngClass]="{'sticky-item-modal': item === 'Model'}"  
              [class.sticky-item-register]="item === 'Plate Number'"
            >{{item}}
              
            </th>
            <ng-container *ngFor="let winner of individualAuctions; index as i">
              <ng-container *ngFor="let row of winner['auction_information']?.[i]?.['description_data'] | keyvalue">
                <th *ngIf="!headingOrder.includes(row.key)">{{row.key}}</th>
              </ng-container>
            </ng-container>

            <th scope="col">Title</th>
            <th scope="col">Vehicle</th>
            <th scope="col">Type</th>
            <th scope="col">Winner</th>
            <th scope="col">Reserve Bid</th>
            <th scope="col">Highest Bid</th>
            <th scope="col">Location</th>
            <th scope="col" style="text-align: center">Approve Status <button type="button" class="tooltip-btn"
                tooltip="This is the auction status; it indicates whether or not the auction requires admin approval."
                placement="bottom"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-question-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path
                    d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                </svg></button></th>
            <th scope="col" style="text-align: center">Payment Status <button type="button" class="tooltip-btn"
                tooltip="This status indicates if the proof of payment document was accepted or not by admin."
                placement="bottom"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-question-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path
                    d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                </svg></button></th>
            <th scope="col">Recycle</th>
            <th scope="col">View</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let winner of individualAuctions">
            <tr>
              <td>
                <div class="auction-dt-tableImage">
                  <img src="{{'' || userFallBackImg}}" alt="" style="height: 50px; width: 50px;">
                </div>
              </td>
              <ng-container *ngFor="let row of winner['auction_information']?.[0]?.['description_data'] | keyvalue">
                <td 
                  *ngIf="headingOrder.includes(row.key)" 
                  [ngClass]="{'sticky-item-modal': row.key === 'Model'}" 
                  [class.sticky-item-register]="row.key === 'Plate Number'"
                >
                  {{row.value ? row.value : '--'}}
                </td>
              </ng-container>
              <ng-container *ngFor="let row of winner['auction_information']?.[0]?.['description_data'] | keyvalue">
                <td *ngIf="!headingOrder.includes(row.key)">{{row.value ? row.value : '--'}}</td>
              </ng-container>

              <td>{{winner['auction_information']?.[0]?.['title']}}</td>
              <td
                *ngIf="winner['auction_information']?.[0]?.['entity_type'] === 'individual'; else vehicleNameFallback">
                {{winner['vehicleName']}}</td>
              <ng-template #vehicleNameFallback>
                <td>--</td>
              </ng-template>
              <td>{{ winner['auction_information']?.[0]?.['entity_type'] | titlecase }}</td>
              <td>{{ winner?.['user_details']?.['first_name'] + ' ' + winner?.['user_details']?.['last_name'] }}</td>
              <td>{{ winner['auction_information']?.[0]?.['lowest_price'] | number:'1.0':'en-US'}}</td>
              <td>{{ winner['winning_bid_amount'] | number:'1.0':'en-US' }}</td>
              <td>{{ winner['auction_information']?.[0]?.['location'] || 'N/A' }}</td>
              <td style="text-align: center">
                <div class="auction-dt-tableTool"
                  *ngIf="winner['auction_information']?.[0]?.['admin'] === true; else notRequired">
                  <div *ngIf="checkingValue.includes(winner['auction_information']?.[0]?.['approval'])">
                    <button type="button" class="btn curved green smallBtn px-4 mr-1"
                      *ngIf="winner['auction_information']?.[0]?.['approval'] === true || winner['auction_information']?.[0]?.['approval'] === null"
                      [disabled]="winner['auction_information']?.[0]?.['approval']"
                      (click)="updateStatus(winner['auction_id'], '1')">{{
                      winner['auction_information']?.[0]?.['approval'] ? 'Approved': 'Approve'}}
                    </button>
                    <button type="button" class="btn curved red smallBtn px-4"
                      *ngIf="winner['auction_information']?.[0]?.['approval'] === false || winner['auction_information']?.[0]?.['approval'] === null"
                      [disabled]="winner['auction_information']?.[0]?.['approval'] === false"
                      (click)="updateStatus(winner['auction_id'], '0')">{{
                      winner['auction_information']?.[0]?.['approval'] === false ? 'Rejected': 'Reject'}}
                    </button>
                  </div>
                </div>
                <ng-template #notRequired>
                  <button type="button" class="btn curved yellow smallBtn px-4 mr-1" disabled>Not Require
                  </button>
                </ng-template>
              </td>
              <td style="text-align: center">
                <ng-container *ngIf="winner['auction_information']?.[0]?.['payment'] === null">
                  <div class="d-flex align-items-center justify-content-center">
                    <img class="paymentIcons" src="{{env + 'assets/img/pending-clock-icon.png'}}">
                    <p class="ml-2">Pending</p>
                  </div>
                </ng-container>
                <ng-container *ngIf="winner['auction_information']?.[0]?.['payment'] === true">
                  <div class="d-flex align-items-center justify-content-center">
                    <img class="paymentIcons" src="{{env + 'assets/img/checkmark-flat.svg'}}">
                    <p class="ml-2">Approved</p>
                  </div>
                </ng-container>
                <ng-container *ngIf="winner['auction_information']?.[0]?.['payment'] === false">
                  <div class="d-flex align-items-center justify-content-center">
                    <img class="paymentIcons" src="{{env + 'assets/img/red-x-icon.png'}}">
                    <p class="ml-2">Rejected</p>
                  </div>
                </ng-container>
              </td>
              <td>
                  <button type="button" class="btn curved green smallBtn px-4 mr-1" *ngIf="winner['auction_information']?.[0]?.['approval'] === false; else nr"
                    [disabled]="winner['auction_information']?.[0]?.['approval']"
                    [ladda]="individualLadda"
                     (click)="recycleIndividualAuction(winner['auction_id'])">Recycle
                  </button>

                  <ng-template #nr>
                    <button type="button" class="btn curved green smallBtn px-4 mr-1" disabled
                    routerLink="/dashboard/auction/edit/{{winner['auction_id']}}">Recycle
                  </button>
                  </ng-template>

              </td>
              <td>
                <a [routerLink]="['/auction-details', winner['auction_id']]" class="auction-bidders">
                  <ion-icon name="eye" class="ion-lg color-yellow"></ion-icon>
                </a>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<br>
<!-- Individual batch Table -->

<div class="auction-content-body position-relative">
  <div class="card auction-content-main m-0 p-3">
    <h3 class=" fs-lg mt-2">Individual batch winner</h3>
    <div class="table-responsive" *ngIf="individualBatchAuctions.length; else fallback">
      <table datatable class="auction-dt table table-striped" [dtOptions]="dtOptions">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Title</th>
            <th scope="col">Type</th>
            <th scope="col">Winner</th>
            <th scope="col">Highest bid</th>
            <th scope="col">Location</th>
            <th scope="col" style="text-align: center">Approve Status <button type="button" class="tooltip-btn"
                tooltip="This is the auction status; it indicates whether or not the auction requires admin approval."
                placement="bottom"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-question-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path
                    d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                </svg></button></th>
            <th scope="col" style="text-align: center">Payment Status <button type="button" class="tooltip-btn"
                tooltip="This status indicates if the proof of payment document was accepted or not by admin."
                placement="bottom"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-question-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path
                    d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                </svg></button></th>
            <th scope="col">View</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let winner of individualBatchAuctions">
            <tr>
              <td>
                <div class="auction-dt-tableImage">
                  <img src="{{'' || userFallBackImg}}" alt="" style="height: 50px; width: 50px;">
                </div>
              </td>
              <td>{{ winner['auction_information']?.[0]?.['title']}}</td>

              <td>{{ (winner['auction_information']?.[0]?.['entity_type'] | removeUnderscore ) | titlecase }}</td>
              <td>{{ winner?.['user_details']?.['first_name'] + ' ' + winner?.['user_details']?.['last_name'] }}</td>
              <td>{{ winner['winning_bid_amount'] | number:'1.0':'en-US' }}</td>

              <td>{{ winner['auction_information']?.[0]?.['location'] || 'N/A' }}</td>
              <td style="text-align: center">
                <div class="auction-dt-tableTool"
                  *ngIf="winner['auction_information']?.[0]?.['admin'] === true; else notRequired">
                  <div *ngIf="checkingValue.includes(winner['auction_information']?.[0]?.['approval'])">
                    <button type="button" class="btn curved green smallBtn px-4 mr-1"
                      *ngIf="winner['auction_information']?.[0]?.['approval'] === true || winner['auction_information']?.[0]?.['approval'] === null"
                      [disabled]="winner['auction_information']?.[0]?.['approval']"
                      (click)="updateStatus(winner['auction_id'], '1')">{{
                      winner['auction_information']?.[0]?.['approval'] ? 'Approved': 'Approve'}}
                    </button>
                    <button type="button" class="btn curved red smallBtn px-4"
                      *ngIf="winner['auction_information']?.[0]?.['approval'] === false || winner['auction_information']?.[0]?.['approval'] === null"
                      [disabled]="winner['auction_information']?.[0]?.['approval'] === false"
                      (click)="updateStatus(winner['auction_id'], '0')">{{
                      winner['auction_information']?.[0]?.['approval'] === false ? 'Rejected': 'Reject'}}
                    </button>
                  </div>
                </div>
                <ng-template #notRequired>
                  <button type="button" class="btn curved yellow smallBtn px-4 mr-1" disabled>Not Require
                  </button>
                </ng-template>
              </td>
              <td style="text-align: center">
                <ng-container *ngIf="winner['auction_information']?.[0]?.['payment'] === null">
                  <div class="d-flex align-items-center justify-content-center">
                    <img class="paymentIcons" src="{{env + 'assets/img/pending-clock-icon.png'}}">
                    <p class="ml-2">Pending</p>
                  </div>
                </ng-container>
                <ng-container *ngIf="winner['auction_information']?.[0]?.['payment'] === true">
                  <div class="d-flex align-items-center justify-content-center">
                    <img class="paymentIcons" src="{{env + 'assets/img/checkmark-flat.svg'}}">
                    <p class="ml-2">Approved</p>
                  </div>
                </ng-container>
                <ng-container *ngIf="winner['auction_information']?.[0]?.['payment'] === false">
                  <div class="d-flex align-items-center justify-content-center">
                    <img class="paymentIcons" src="{{env + 'assets/img/red-x-icon.png'}}">
                    <p class="ml-2">Rejected</p>
                  </div>
                </ng-container>
              </td>
              <td>
                <a [routerLink]="['/auction-details', winner['auction_id']]" class="auction-bidders">
                  <ion-icon name="eye" class="ion-lg color-yellow"></ion-icon>
                </a>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<br>

<!-- Bulk Table -->
<div class="auction-content-body position-relative">
  <div class="card auction-content-main m-0 p-3">
    <h3 class=" fs-lg mt-2">Bulk winner</h3>
    <div class="table-responsive" *ngIf="bulkAuctions.length; else fallback">
      <table datatable class="auction-dt table table-striped" [dtOptions]="dtOptions">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Title</th>
            <th scope="col">Type</th>
            <th scope="col">Total Vehicle</th>
            <th scope="col">Winner</th>
            <th scope="col">Reserve Bid</th>
            <th scope="col">Highest bid</th>
            <th scope="col">Location</th>
            <th scope="col" style="text-align: center">Approve Status <button type="button" class="tooltip-btn"
                tooltip="This is the auction status; it indicates whether or not the auction requires admin approval."
                placement="bottom"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-question-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path
                    d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                </svg></button></th>
            <th scope="col" style="text-align: center">Payment Status <button type="button" class="tooltip-btn"
                tooltip="This status indicates if the proof of payment document was accepted or not by admin."
                placement="bottom"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-question-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path
                    d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                </svg></button></th>
            <th>Recycle</th>
            <th scope="col">View</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let winner of bulkAuctions">
            <tr>
              <td>
                <div class="auction-dt-tableImage">
                  <img src="{{'' || userFallBackImg}}" alt="" style="height: 50px; width: 50px;">
                </div>
              </td>
              <td>{{ winner['auction_information']?.[0]?.['title']}}</td>

              <td>{{ (winner['auction_information']?.[0]?.['entity_type'] | removeUnderscore ) | titlecase }}</td>
              <td>{{ winner['numberOfVehicle']}}</td>
              <td>{{ winner?.['user_details']?.['first_name'] + ' ' + winner?.['user_details']?.['last_name'] }}</td>
              <td>{{ winner['auction_information']?.[0]?.['lowest_price'] | number:'1.0':'en-US'}}</td>
              <td>{{ winner['winning_bid_amount'] | number:'1.0':'en-US' }}</td>
              <td>{{ winner['auction_information']?.[0]?.['location'] || 'N/A' }}</td>
              <td style="text-align: center">
                <div class="auction-dt-tableTool"
                  *ngIf="winner['auction_information']?.[0]?.['admin'] === true; else notRequired">
                  <div *ngIf="checkingValue.includes(winner['auction_information']?.[0]?.['approval'])">
                    <button type="button" class="btn curved green smallBtn px-4 mr-1"
                      *ngIf="winner['auction_information']?.[0]?.['approval'] === true || winner['auction_information']?.[0]?.['approval'] === null"
                      [disabled]="winner['auction_information']?.[0]?.['approval']"
                      (click)="updateStatus(winner['auction_id'], '1')">{{
                      winner['auction_information']?.[0]?.['approval'] ? 'Approved': 'Approve'}}
                    </button>
                    <button type="button" class="btn curved red smallBtn px-4"
                      *ngIf="winner['auction_information']?.[0]?.['approval'] === false || winner['auction_information']?.[0]?.['approval'] === null"
                      [disabled]="winner['auction_information']?.[0]?.['approval'] === false"
                      (click)="updateStatus(winner['auction_id'], '0')">{{
                      winner['auction_information']?.[0]?.['approval'] === false ? 'Rejected': 'Reject'}}
                    </button>
                  </div>
                </div>
                <ng-template #notRequired>
                  <button type="button" class="btn curved yellow smallBtn px-4 mr-1" disabled>Not Require
                  </button>
                </ng-template>
              </td>
              <td style="text-align: center">
                <ng-container *ngIf="winner['auction_information']?.[0]?.['payment'] === null">
                  <div class="d-flex align-items-center justify-content-center">
                    <img class="paymentIcons" src="{{env + 'assets/img/pending-clock-icon.png'}}">
                    <p class="ml-2">Pending</p>
                  </div>
                </ng-container>
                <ng-container *ngIf="winner['auction_information']?.[0]?.['payment'] === true">
                  <div class="d-flex align-items-center justify-content-center">
                    <img class="paymentIcons" src="{{env + 'assets/img/checkmark-flat.svg'}}">
                    <p class="ml-2">Approved</p>
                  </div>
                </ng-container>
                <ng-container *ngIf="winner['auction_information']?.[0]?.['payment'] === false">
                  <div class="d-flex align-items-center justify-content-center">
                    <img class="paymentIcons" src="{{env + 'assets/img/red-x-icon.png'}}">
                    <p class="ml-2">Rejected</p>
                  </div>
                </ng-container>
              </td>
              <td>
                <button type="button" class="btn curved green smallBtn px-4 mr-1" *ngIf="winner['auction_information']?.[0]?.['approval'] === false; else bulknr"
                    [disabled]="winner['auction_information']?.[0]?.['approval']"
                    [ladda]="bulkLadda"
                    (click)="recycleBulkAuction(winner['auction_id'])"
                    >Recycle
                  </button>

                  <ng-template #bulknr>
                    <button type="button" class="btn curved green smallBtn px-4 mr-1" disabled
                    >Recycle
                  </button>
                  </ng-template>
              </td>
              <td>
                <a [routerLink]="['/auction-details', winner['auction_id']]" class="auction-bidders">
                  <ion-icon name="eye" class="ion-lg color-yellow"></ion-icon>
                </a>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div>
  <ng-template #fallback>
    <h3 class="ml-4 pt-3">No reports found</h3>
  </ng-template>
</div>

<app-loader *ngIf="loading"></app-loader>